<template>
  <div>
    <DataListHeading
      v-if="isDataListHeading"
      :label="headingConfig.label"
      :divider="headingConfig.divider"
      :search-field="headingConfig.searchField"
      disabled
      @getSearch="getSearch"
    />
    <v-col
      v-if="$slots.filters"
      cols="12"
      class="px-0 py-1"
    >
      <slot name="filters" />
    </v-col>
    <v-data-table
      :headers="headers"
      fixed-header
      :items="items"
      :hide-default-footer="items.length > 10 ? hideDefaultFooter : true"
      :items-per-page="itemsPerPage"
      :class="tableShadow ? 'elevation-1' : ''"
      :loading="loading"
      no-data-text="Дані відсутні"
      disable-sort
      :height="height"
      loading-text="Завантаження данних"
      :page.sync="page"
      @page-count="pageCount = $event"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td
            v-for="(column, i) in headers"
            :key="`column-${i}`"
            :style="column.style"
          >
            <component
              :is="cellTypes[column.type] || column.component"
              v-if="column.type || column.component"
              :value="!column.value ? item : item[column.value]"
              :dict="column.dict ? column.dict : ''"
              v-bind="column.props"
            />
            <ReferenceTitle
              v-else-if="column.reference && item[column.value]"
              :id="item[column.value].id || item.id"
              :title="column.getTitle ? column.getTitle(item[column.value]) : item[column.value].title"
              :component-name="column.componentName"
            />
            <span
              v-else
              v-text="item[column.value]"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-pagination
      v-if="displayPagination"
      v-model="page"
      :length="pageCount"
    />
  </div>
</template>

<script>
import DateCell from "../cells/DateCell.vue";
import TextCell from "../cells/TextCell.vue";
import ListCell from "../cells/ListCell.vue";
import DecimalCell from "../cells/DecimalCell.vue";
import DataListHeading from "../DataListHeading.vue";

const cellTypes = {
  date: "DateCell",
  text: "TextCell",
  list: "ListCell",
  decimal: "DecimalCell",
};

export default {
  components: {
    DateCell,
    TextCell,
    ListCell,
    DecimalCell,
    DataListHeading,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      default: "63vh",
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    displayPagination: {
      type: Boolean,
      default: false,
    },
    tableShadow: {
      type: Boolean,
      default: true,
    },
    hideDefaultFooter: {
      type: Boolean,
      default: true,
    },
    isDataListHeading: {
      type: Boolean,
      default: false,
    },
    headingConfig: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    page: 1,
    pageCount: 0,
  }),
  computed: {
    cellTypes() {
      return cellTypes;
    },
  },
  methods: {
    getSearch(search) {
      this.$emit("search", search);
    },
  },
};
</script>
